import React from 'react';
import styled from 'styled-components';
import Section, { SectionTitle } from '../../common/Section.js';
import Card, { CardImage, CardBody } from '../../common/Card.js';
import Button from '../../common/Button.js';
import { Link } from 'react-router-dom';

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BlogCard = styled(Card)`
  .meta {
    display: flex;
    gap: 1rem;
    font-size: 0.875rem;
    color: var(--gray);
    margin-bottom: 1rem;
    
    .category {
      color: var(--secondary);
      font-weight: 600;
    }
  }
`;

const BlogSection = () => {
  const posts = [
    {
      id: 1,
      title: "7 Things to Look for When Buying a New Home",
      excerpt: "Discover the key features to consider when purchasing a new home to ensure it meets your needs and provides value for years to come.",
      date: "March 15, 2023",
      category: "Buying Tips",
      image: "/images/blog1.png"
    },
    {
      id: 2,
      title: "Understanding the Home Building Process",
      excerpt: "A step-by-step guide to the home construction process from initial planning and design to final walkthrough and closing.",
      date: "February 28, 2023",
      category: "Construction",
      image: "/images/blog2.png"
    },
    {
      id: 3,
      title: "Partnering for Land Development",
      excerpt: "Learn about joint venture opportunities for landowners looking to unlock the full potential of their property with an experienced builder.",
      date: "April 10, 2023",
      category: "Land Development",
      image: "/images/blog3.png"
    }
  ];
  
  return (
    <Section>
      <div className="container">
        <SectionTitle>
          <h2>Latest from Our Blog</h2>
          <p>News, tips, and insights from the world of home building and real estate</p>
        </SectionTitle>
        
        <BlogGrid>
          {posts.map(post => (
            <BlogCard key={post.id}>
              <CardImage height="220px">
                <img src={post.image} alt={post.title} />
              </CardImage>
              <CardBody>
                <div className="meta">
                  <span className="date">{post.date}</span>
                  <span className="category">{post.category}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <Button as={Link} to={post.id === 1 ? '/blog/1' : post.id === 2 ? '/blog/2' : '/blog/land-development'} variant="text">
                  Read More
                </Button>
              </CardBody>
            </BlogCard>
          ))}
        </BlogGrid>
      </div>
    </Section>
  );
};

export default BlogSection;